module.exports = __webpack_public_path__ + "assets/img/Edito_Alexandre-Rousseau_cover.d053bd5e-ps.jpg";